export const fmtGHS = (n) =>
  `GHS ${Number(n || 0).toLocaleString("en-GH", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const fmtNum = (n) => Number(n || 0).toLocaleString("en-GH");

// Product display name (generic + strength + dosage form) computed server-side.
export const pName = (p) => p?.display_name || p?.generic_name || "";
export const pMatch = (p, s) => {
  const words = (s || "").toLowerCase().split(/\s+/).filter(Boolean);
  if (!words.length) return true;
  const text = [p.display_name, p.generic_name, p.brand, p.sku, p.form, p.strength].map((v) => (v || "").toLowerCase()).join(" ");
  return words.every((w) => text.includes(w));
};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  return d.toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
};

export const daysUntil = (isoDate) => {
  if (!isoDate) return null;
  const d = new Date(isoDate);
  return Math.ceil((d - new Date()) / 86400000);
};
